import React, { useState, useEffect } from 'react';
import { List, Spin, Empty, Avatar } from 'antd';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { actions as orgsActions } from '/src/views/Orgs/redux';
import { currentUserSelector } from '../Auth/Login/selector';
import { orgsSelector } from './selector';
import CustomListItem from '/src/components/CustomListItem/CustomListItem';

const ProfileIcon = ({item}) => (
  <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
    {item && item.name?.substr(0, 1)?.toUpperCase()}
  </Avatar>
)

// Recursive component to render schools with nested children
const SchoolItem = ({ school, level = 0 }) => {
  const hasNestedChildren = school.nested_children && school.nested_children.length > 0;
  
  return (
    <div style={{ marginLeft: `${level * 20}px` }}>
      <CustomListItem 
        item={school} 
        title={school.name} 
        avatar={<ProfileIcon item={school} />} 
        description={school.address}
        actions={[]}
      />
      {hasNestedChildren && (
        <div className="m-l-10">
          {school.nested_children.map((nestedSchool) => (
            <SchoolItem 
              key={nestedSchool.id} 
              school={nestedSchool} 
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const SchoolsList = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector());
  const orgId = currentUser?.org_id;
  const allOrgs = useSelector(orgsSelector());
  
  const fetchSchools = () => {
    try {
     dispatch(orgsActions.fetch({params: {by_parent_id: orgId, page_size: 50, with_nested_children: true, should_serialize: true}}))
     setLoading(false)
    } catch (error) {
      console.error('Error fetching schools:', error);
    }
  };

  useEffect(() => {
    if(orgId){
      fetchSchools();
    }
  }, [orgId]);

  if (loading) {
    return (
      <div>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <List
        dataSource={allOrgs}
        renderItem={(school) => (
          <SchoolItem key={school.id} school={school} />
        )}
      />
    </div>
  );
};

export default SchoolsList;
